export default __webpack_public_path__ + "static/media/linux.7313ad25.png";